import { render, staticRenderFns } from "./InputRichText.vue?vue&type=template&id=9c6cad52&scoped=true&"
import script from "./InputRichText.vue?vue&type=script&lang=js&"
export * from "./InputRichText.vue?vue&type=script&lang=js&"
import style0 from "@/sass/07_elements/input-richtext.scss?vue&type=style&index=0&id=9c6cad52&scoped=true&lang=scss&"
import style1 from "@/sass/07_elements/rich-text.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6cad52",
  null
  
)

export default component.exports